
import {Uploader} from 'mixins'
import $profile from 'stores/profile'

export default {
  mixins: [Uploader],
  emits: ['removed'],
  computed: {
    display_name() {
      return $profile.display_name
    },
    avatar_id() {
      return $profile.avatar_id
    },
  },
  methods: {
    async onRemoveAvatar() {  
      // for avatars we don't care about actual removal result on server
      // any errors are insigninificant, do not crash the UI
      const avatar_id = this.avatar_id
      this.store.delete(avatar_id).catch(() => {})
      this.$emit('removed', avatar_id)
    },
  }
}
